import React, { useState } from 'react';
import ButtonLarge from '../components/Button-large';
import '../css/Contact.css';
import Project from '../components/Projects';
import { MdSend, MdCheck } from 'react-icons/md';
import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';



const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch('https://pvbastos.com/contact.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setSubmitted(true);
    } else {
      alert('There was an error sending your message.');
    }
  } catch (err) {
    alert('There was an error sending your message.');
  }
};

  return (
    
     <div className='contact'>
      <div className='shapes-container-inside blur-mobile'>
              <Shape1 className="shape shape-1" />
              <ShapeRectangle className="shape shape-2" />
              <Shape3 className="shape shape-3" />
              <Shape1 className="shape shape-4" />
            </div>
      <div className='shapes-container-inside blur-desktop hide-mobile'>
      
                <ShapeRectangle className="shape shape-5" />
                <Shape3 className="shape shape-6" />
      </div>
      <div className="contact-hero">
        <h1>Let's work together!</h1>
        <p>If you're interested in collaborating or have any questions, feel free to reach out. I'm always open to discussing new projects and opportunities.</p>
      </div>

      <div className="contact-page">
        {submitted ? (
          <div className="contact-success">
            <MdCheck className="contact-success-icon" size={48} />
            <div className='contact-success-text'>
            <h3>Thank you for your message!</h3>
            <p>We'll get back to you shortly.</p>
            </div>
            </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                name="message"
                className="form-textarea"
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
              />
            </div>
            <div className="form-actions">
              <ButtonLarge
                type="submit"
                label="Send message"
                className="form-submit-btn"
                icon={() => <MdSend className="animated-icon" />} // Animated icon
              />
            </div>
          </form>
          
        )}
      </div>

      <div className="contact-extra">
        <span className='contact-email'>Or send me an e-mail at <a href="mailto:contact@pvbastos.com" className="contact-email">
          contact@pvbastos.com
        </a></span>
      </div>




      
      
    </div>
  );
};

export default Contact;